module.exports = __webpack_public_path__ + "src/assets/img/trank_open_light_stop.5975d8d1.svg";